import React, { useState } from 'react';
import Markdownkatexnew from "../components/Markdown";
import Select, { components } from 'react-select';
// import './App.css';

const Wwwww = [
  { value: 'llama3', label: 'llama3' },
  { value: 'gemma4', label: 'gemma4' },
  { value: 'deepseek-r1', label: 'deepseek-r1' },
  { value: 'Qwen2.5-Coder', label: 'Qwen2.5-Coder' },
  { value: 'deepseek-v4-pro', label: 'deepseek-v4-pro' },
];

function App() {
  const [input, setInput] = useState('');
  const [response, setResponse] = useState('');
  const [model, setModel] = useState('gemma4');
  const [loading, setLoading] = useState(false);

  const handleChange = (selectedOption) => {
    setModel(selectedOption.value);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    setLoading(true);
    setResponse('');

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/users/userReduce`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: input,
          model: model //gemma4  Change this to your local model name
        }),
      });

      const data = await res.json();
      if (data.response) {
        setResponse(data.response);
      } else {
        setResponse('Error: No hay respuesta recibida.');
      }
    } catch (err) {
      setResponse('Error al conectar con el backend server.');
    } finally {
      setLoading(false);
    }
  };

  // import Select from 'react-select';

  const SearchSelect = (props) => {
    const { options, defaultValue, onChange, name, label } = props;
    return (
      <>
        {label && <label htmlFor="search-select">{label}</label>}
        <Select
          options={options}
          defaultValue={defaultValue}
          onChange={onChange}
          name={name}
          id="search-select"
        />
      </>
    );
  };


  return (
    <div style={{ maxWidth: '600px', margin: '50px auto', padding: '20px', fontFamily: 'Arial' }}>
      <h5>Asistente Ollama AI</h5>
      <form onSubmit={handleSubmit} className='' >
        <input
          type="text"
          className='form-control'
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Pregunta algo..."
          disabled={loading}
        />
        <div className=''>
          <p style={{marginBottom:"0em", marginTop:".1em"}}>Modelo</p>
          <Select defaultValue={Wwwww.filter(({ value }) => value === model)} onChange={handleChange} options={Wwwww} disabled={loading} placeholder="Seleccione item" />

          <button type="submit" className='btn btn-warning text-center mt-1 w-100' disabled={loading}>
            {loading ? 'Pensando...' : 'Enviar'}
          </button>

        </div>
      </form>
      <div style={{ marginTop: '20px', padding: '15px', background: '#f4f4f4', borderRadius: '5px', minHeight: '100px', whiteSpace: 'pre-wrap' }}>
        <p>Respuesta:</p>
        <Markdownkatexnew>
          {response}
        </Markdownkatexnew>
      </div>
    </div>
  );
}

export default App